import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { GoalsModel } from 'src/app/models/goals.model';

@Component({
  selector: 'app-goals-delete-modal',
  templateUrl: './goals-delete-modal.component.html',
  styleUrls: ['./goals-delete-modal.component.scss']
})
export class GoalsDeleteModalComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<GoalsDeleteModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: GoalsModel
  ) { }

  ngOnInit(): void {
  }

  onConfirmDelete(formValues: any) {
    this.dialogRef.close({
      deleteGoal: true});
      
    console.log("Emit delete goals event.");
  }

  onCancelClick() {
    this.dialogRef.close({dialogRedirect: false});
  }

  dialogRedirect() {
    this.dialogRef.close({dialogRedirect: true});
    
  }

}
